(function ($) {
    let currentBVID;
    const ICON_SCENT_ICON_IMAGE_BASE = '/wp-content/themes/electro/views/modules/defs.svg#icon-scent-';
    const $stars = $('.js-inline-rating .product__bv-rating');

    /*
     * changeBV
     *   change BV controls as scent changes
     */
    function changeBV(bvid) {
        $('[data-bv-show="inline_rating"]').each(function () {
            $(this).attr('data-bv-product-id', bvid);
        });
        $('[data-bv-show="reviews"]').attr('data-bv-product-id', bvid);
    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp(`[\\?&]${  name  }=([^&#]*)`);
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // Change markup in the features grid element when scent icon is changed
    // if ACF override field data is present in data- attributes.
    function updateFeatures(data) {
        if (!data) {
            return;
        }

        const $originalFirstFeature = $('.features--left li:not(.feature-override)').first();

        if (data.firstFeatureIcon && data.firstFeatureName && data.firstFeatureCopy) {
            const { firstFeatureIcon, firstFeatureName, firstFeatureCopy } = data;
            let $firstFeatureOverride = $('.features--left .feature-override');

            if ($firstFeatureOverride.length < 1) {
                // Make a clone to show instead of the original
                const $featureClone = $originalFirstFeature.clone().addClass('feature-override', 'hide');
                $featureClone.prependTo($('.features--left'));
            }

            $firstFeatureOverride = $('.features--left .feature-override');

            $firstFeatureOverride.find('span.heading').text(firstFeatureName);
            $firstFeatureOverride.find('p').text(firstFeatureCopy);
            const iconBasePath = $originalFirstFeature.find('use').attr('xlink:href').split('#')[0];
            const icon = `${iconBasePath}#icon-feature-${firstFeatureIcon}`;
            $firstFeatureOverride.find('use').attr('xlink:href', icon);

            $firstFeatureOverride.removeClass('hide');
            $originalFirstFeature.addClass('hide');
        } else {
            $('.features--left .feature-override').addClass('hide');
            $originalFirstFeature.removeClass('hide');
        }

        if (data.featureImage) {
            const $originalImage = $('.features-image:not(.feature-override)');

            let $overrideImage = $('.features-image.feature-override');

            if ($overrideImage.length > 0) {
                // Just switch the src of the existing override image element
                $overrideImage.attr('src', data.featureImage).attr('srcset', data.featureImage);
            } else {
                // Make a clone to show instead of the original
                const $imageClone = $originalImage
                    .clone()
                    .addClass('feature-override', 'hide')
                    .attr('src', data.featureImage)
                    .attr('srcset', data.featureImage);
                $imageClone.prependTo($('.features-image').parent());
                $overrideImage = $('.features-image.feature-override');
            }

            $overrideImage.removeClass('hide');
            $originalImage.addClass('hide');
        } else {
            $('.features-image.feature-override').addClass('hide');
            $('.features-image:not(.feature-override)').removeClass('hide');
        }
    }

    // init page
    $(() => {
        // handle page data setup
        const productDataSection = $('#product-data');
        const pageData = productDataSection.data();


        const $activeIcon = $('.js-scent-icon.active');
        const data = $activeIcon.find('.icon').data();

        const buyNowBtn = $('button#wtb');

        updateFeatures(data);

        let syncScentAndSize = false;
        if (pageData.sync_scent_size) {
            syncScentAndSize = true;
        }

        if (pageData.initialReviewCount) {
            $('.js-has-no-reviews').hide();
        } else {
            $('.js-has-reviews').hide();
        }
        if (!pageData.bvid) {
            $('.js-inline-rating').hide();
            $('.review-teaser').hide();
        } else {
            currentBVID = pageData.bvid;
            $('.js-inline-rating').show();
        }

        const $scentIcons = $('.js-scent-icon').on('click', (e) => {
            // Make sure we get the svg, which has the scent data- attached
            const $this = $(e.currentTarget);

            if ($this.hasClass('active')) {
                return;
            }

            const scentData = $this.find('.icon').data();

            // Change H1
            $('.js-product-name').html(scentData.product);

            // Update upcs for buy now button if it exists
            let upc = null;
            if(buyNowBtn.length) {
                upc = scentData.upc;
                buyNowBtn.attr('data-upc', upc);
                buyNowBtn.attr('data-eans', upc);
                productDataSection.attr('data-wtb-upc', upc);
            }

            // push data into browser History
            //  changing page happens in statechange handler
            History.pushState(scentData, scentData.seotitle, scentData.url);
        });

        const $sizeIcons = $('.js-size-icon').on('click', (e) => {
            const $this = $(e.target);
            if ($this.hasClass('active')) {
                return;
            }

            $sizeIcons.removeClass('active');
            $this.addClass('active');

            // update page based on selected item
            const data = $this.data();
            $('.js-size-dimensions').text(data.dimensions);
            if (data.image) {
                $('.js-size-image').attr('src', data.image);
                $('.js-size-image').attr('srcset', data.image);
            }

            // sync scent icons
            if (syncScentAndSize) {
                const index = $sizeIcons.index($sizeIcons.filter('.active'));
                $scentIcons.eq(index).click();
            }
        });

        // initial active size icon
        let sizeActiveIndex = 0;
        if (syncScentAndSize) {
            sizeActiveIndex = $scentIcons.index($scentIcons.filter('.active'));
        }
        $sizeIcons.eq(sizeActiveIndex).addClass('active');

        function reloadScript() {
            const src1 = $('.reload-script-1').attr('src');
            $('.reload-script-1').attr('src', `${src1.split('?')[0]  }?${  Math.floor(Math.random() * 10000000)}`);
            const src2 = $('.reload-script-2').attr('src');
            $('.reload-script-2').attr('src', `${src2.split('?')[0]  }?${  Math.floor(Math.random() * 10000000)}`);
        }

        $(window).on('statechange', () => {
            const state = History.getState();
            const { data } = state;

            if (!data.bvid) {
                $('.js-inline-rating').hide();
                $('.review-teaser').hide();
            } else {
                currentBVID = data.bvid;
                $('.js-inline-rating').show();
                $('.review-teaser').show();
            }

            // update active class on scent icons
            // update scent images
            const $activeScent = $scentIcons.filter('.active');
            $activeScent.removeClass('active');
            $('use', $activeScent).attr(
                'xlink:href',
                ICON_SCENT_ICON_IMAGE_BASE + $activeScent.find('.icon').data('scentIcon')
            );
            const $newScent = $(`.js-scent-icon .icon[data-name="${data.name}"]`)
                .closest('.js-scent-icon')
                .addClass('active');
            $('use', $newScent).attr('xlink:href', `${ICON_SCENT_ICON_IMAGE_BASE + data.scentIcon}-active`);

            // sync size icons
            if (syncScentAndSize) {
                const index = $scentIcons.index($scentIcons.filter('.active'));
                $sizeIcons.eq(index).click();
            }

            // update page based on selected scent
            $('.js-scent-name').html(data.name);
            $('.js-scent-description').html(data.desc);
            $('.js-glamour-image').attr('src', data.glamourImage);
            $('.js-glamour-image').attr('srcset', data.glamourImage);
            $('.js-bv-rating').text(data.bvRating);

            updateFeatures(data);

            // show and hide elements based on whether product
            // has any bv reviews
            if (data.bvReviewCount) {
                $('.js-has-no-reviews').hide();
                $('.js-has-reviews').show();
            } else {
                $('.js-has-no-reviews').show();
                $('.js-has-reviews').hide();
            }

            // Fetch new slides
            $('#SwiperWrapper2').load(`${document.URL  } #SwiperWrapper2>*`);
            $('#SwiperWrapper1').load(`${document.URL  } #SwiperWrapper1>*`, () => {

                // Wait for the new slides to load
                const waitForSwiperSlides = ()=>{
                    return new Promise((resolve) => {
                        const checkSlides = () => {
                            const slides = $('#SwiperWrapper1 .swiper-slide');
                            if (slides.length > 0) {
                                resolve(slides);
                            } else {
                                setTimeout(checkSlides, 100); // Check again after 100ms
                            }
                        };
                        checkSlides();
                    });
                }

                // Re-run swiper after the new slides have been loaded
                waitForSwiperSlides().then((slides) => {
                    window.PDPSwiper.run();
                });
            });

            changeBV(data.bvid);
            playGalleryVideo();
        });

        // copy star ratings from top of page to review teaser panel
        //         if (pageData.initialReviewCount) {
        //             var id = setInterval(function () {
        //                 var html = $stars.html();
        //                 if (!html) {
        //                     return;
        //                 }
        //                 $('.js-bv-inline-stars-copy').html(html);
        //                 clearInterval(id);
        //             }, 500);
        //         }
    });

    // Play product family video if `#video` is in URL
    $(document).ready(() => {
        const { hash } = window.location;
        if (hash === '#video') {
            $('#play-button').click();
        } else if (hash === '#review' || getUrlParameter('bvdata') == 'action=rr_submit_review') {
            // write review needs $BV initialized
            const writeReview = function () {
                $('.js-write-review').click();
            };
            if (window.$BV) {
                writeReview();
            } else {
                const bvOldCallback = window.bvCallback;
                window.bvCallback = function (BV) {
                    if (bvOldCallback) {
                        bvOldCallback(BV);
                    }
                    writeReview();
                };
            }
        }
    });

    // Play product family video if `#video-modal` is in URL or clicked on, when in the gallery.
    function playGalleryVideo() {
        $('a[href="#video-modal"]').click((e) => {
            e.preventDefault();
            $('#video-modal').modal('show');
        });

        $('button.close').click((e) => {
            e.preventDefault();
            $('#video-modal').modal('hide');
        })

        $('#video-modal').on('shown.bs.modal', () => {
            $('#video-modal__video').get(0).play();
        });

        $('#video-modal').on('hidden.bs.modal', function (e) {
            $('#video-modal__video').get(0).pause();
            $('#video-modal__video').get(0).currentTime = 0;
        });
    }

    // Handle the video modal on load.
    $(document).ready(() => {
        playGalleryVideo();
    });

    // start write review process
    $('.js-has-no-reviews, .js-write-review').on('click', () => {
        $BV.ui('rr', 'submit_review', {
            productId: currentBVID,
        });

        $BV.configure('global', {
            events: {
                submissionSubmitted (data) {
                    // JS to be triggered once submission is submitted.
                    // Redirect to coupon page
                    if ($('#product-data').attr('data-bvid') == 'cling-wrap-100') {
                        const promoID = 105523345; // ClingWrap
                        window.location.href = `/offers/review-coupon/?promo=${  promoID}`;
                    } else if ($('#product-data').attr('data-bvid') == 'press-n-seal-40') {
                        const promoID = 105523365; // PressNSeal
                        window.location.href = `/offers/review-coupon/?promo=${  promoID}`;
                    }
                },
            },
        });

        return false;
    });

    // slideshow for scents
    const scentCount = $('.scent-list li').length;
    function initSlickShow() {
        $('.scent-list').slick({
            infinite: true,
            slidesToShow: scentCount,
            slidesToScroll: 2,
            dots: false,
            arrows: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        // centerMode: true,
                        arrows: true,
                        dots: false,
                        adaptiveHeight: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: 'unslick',
                },
            ],
        });
    }

    if (scentCount > 3 && window.innerWidth < 768) {
        // Styles are already loaded
        console.log('init slick');
        initSlickShow();
    }

    // link in panel should toggle review display & scroll if opening
    const $open = $('.open-sesame');
    const $bvWrapper = $('.bv-wrapper');
    $open.on('click', (e) => {
        e.preventDefault();
        $bvWrapper.slideToggle(500, () => {
            $open.toggleClass('minus');
        });
        if (!$open.hasClass('minus')) {
            // scroll if not open
            $('html, body').animate(
                {
                    scrollTop: $('#review-jump-link').offset().top,
                },
                500
            );
        }
    });

    // handle read review buttons
    // top link always opens & scrolls to reviews
    $('.open-sesame-top').on('click', (e) => {
        e.preventDefault();
        $bvWrapper.show();
        $open.addClass('minus');
        $('html, body').animate(
            {
                scrollTop: $('#review-jump-link').offset().top,
            },
            500
        );
    });

    // handle #shop to open shop panel
    const $shopButton = $('.js-buy-button');
    function openShop() {
        if ($shopButton.is(':visible')) {
            $shopButton.click();
        } else {
            setTimeout(openShop, 250);
        }
    }
    if (location.hash === '#shop') {
        openShop();
    }
})(jQuery);
